"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.verifyMigrationToken = void 0;
var verifyToken_1 = require("./verifyToken");
var verifyMigrationToken = function (args) { return (0, verifyToken_1.verifyToken)(args); };
exports.verifyMigrationToken = verifyMigrationToken;
